<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
    <div class="entity-config-shell d-flex flex-column gap-3 mx-auto">
        <section class="entity-config-top rounded-4 overflow-hidden border-0">
            <div class="entity-config-top-hero px-2 px-md-2 py-2">
                <div class="row g-2 align-items-start flex-nowrap p-2">
                    <div class="col">
                        <p class="text-white fw-bold mb-1 text-x">Manage Verification Services</p>
                        <p class="text-xs text-white mb-0">
                            View and configure active verification services available to your platform.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Service cards -->
        <section class="row g-3 g-xl-4 pt-1">
            <div v-for="service in services" :key="service.key" class="col-12 col-md-6 col-lg-4">
                <article class="card h-100 border border-purple border-opacity-50 shadow-lg rounded-4">
                    <div class="card-body p-4 d-flex flex-column h-100">
                        <div class="d-flex justify-content-between align-items-start mb-3">
                            <div
                                class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                                <i class="bi fs-5" :class="service.icon"></i>
                            </div>
                            <div class="text-primary small fw-bold pt-1">{{ service.price }}</div>
                        </div>

                        <p class="text-x text-dark mb-2 fw-bold">{{ service.title }}</p>
                        <p class="text-secondary text-xs lh-base mb-3 flex-grow-1">{{ service.description }}</p>

                        <div class="border-top pt-3 mt-auto">
                            <div class="d-flex align-items-center gap-3 w-100">
                                <button
                                   class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1" @click="redirect_to_configure_services(service)">
                                    View
                                </button>
                            </div>
                        </div>
                    </div>
                </article>
            </div>

            <!-- Empty state -->
            <div v-if="services.length === 0" class="col-12">
                <div class="text-center text-muted py-5">
                    <i class="bi bi-inbox fs-2 d-block mb-2"></i>
                    <p class="text-xs mb-0">No verification services available.</p>
                </div>
            </div>
        </section>
    </div>
</div>
